<template>
  <b-container fluid>
    <b-row style="margin-bottom: 1rem;" align-h="between">
      <template
        v-if="
          object.tetrapodcategory.options.length > 0 &&
            object.country.options.length > 0 &&
            object.year.options.length > 0
        "
      >
        <b-col cols="10">
          <span>
            縣市別:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
              v-model="object.country.value"
              :options="object.country.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
          <span>
            家畜別:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 15vh; display: inline-grid; margin-right: 10px;"
              v-model="object.tetrapodcategory.value"
              :options="object.tetrapodcategory.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
          <span>
            年度:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 15vh; display: inline-grid; margin-right: 10px;"
              v-model="object.year.value"
              :options="object.year.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
        </b-col>
      </template>
      <template v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </template>
    </b-row>
    <template v-if="object.table.ifshow">
      <b-row>
        <b-col>
          <b-table
            :items="object.table.items"
            :fields="object.table.fields"
            :current-page="object.table.currentPage"
            :per-page="object.table.perPage"
            :busy="object.table.isBusy"
            head-variant="green"
            responsive
            striped
            hover
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col>
          <b-pagination
            v-model="object.table.currentPage"
            :total-rows="object.table.totalRows"
            :per-page="object.table.perPage"
            small
          ></b-pagination>
        </b-col>
        <b-col cols="auto">
          <span>共 {{ object.table.totalRows }}筆資料</span>
        </b-col>
      </b-row> -->
    </template>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      object: {
        tetrapodcategory: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        country: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        year: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        table: {
          ifshow: false,
          fields: [
            {
              key: "LS_CITY",
              label: "縣市別",
              visible: true,
            },
            {
              key: "LS_TYPE",
              label: "家畜別",
              visible: true,
            },
            {
              key: "LS_YEAR",
              label: "年份",
              visible: true,
            },
            {
              key: "LS_NUMS",
              label: "數值",
              visible: true,
            },
            {
              key: "LS_UNIT",
              label: "單位",
              visible: true,
            },
          ],
          items: [],
          allitems: [],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          isBusy: true,
          pageoptions: [10, 50, 100],
        },
      },
      apiGetLiveStockCityList: (data) =>
        this.userRequest.post("/API/Default/getLiveStockCityList", data),
      apiGetLiveStockTypeList: (data) =>
        this.userRequest.post("/API/Default/getLiveStockTypeList", data),
      apiGetLiveStockDateList: (data) =>
        this.userRequest.post("/API/Default/getLiveStockDateList", data),
      apiGetLiveStockDataList: (data) =>
        this.userRequest.post("/API/Default/getLiveStockDataList", data),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.FunctionToken(this.getLiveStockCityList, {});
      this.FunctionToken(this.getLiveStockTypeList, {});
      this.FunctionToken(this.getLiveStockDateList, {});
    },
    getLiveStockCityList(data) {
      this.apiGetLiveStockCityList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.country.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.LS_CITY,
                code: x.LS_CITY,
                disabled: true,
              };
              this.object.country.options.push(obj);
            });
            this.object.country.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            this.object.country.value = {
              label: "嘉義縣",
              code: "嘉義縣",
              disabled: true,
            };
          }
        })
        .catch((err) => console.warn(err));
    },
    getLiveStockTypeList(data) {
      this.apiGetLiveStockTypeList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.tetrapodcategory.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.LS_TYPE,
                code: x.LS_TYPE,
                disabled: true,
              };
              this.object.tetrapodcategory.options.push(obj);
            });
            this.object.tetrapodcategory.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            this.object.tetrapodcategory.value = {
              label: "牛",
              code: "牛",
              disabled: true,
            };
          }
        })
        .catch((err) => console.warn(err));
    },
    getLiveStockDateList(data) {
      this.apiGetLiveStockDateList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.year.options = [];
            let arr = JSON.parse(json.Data);
            //console.log("arr",arr)
            arr.forEach((x) => {
              let obj = {
                label: x.LS_YEAR,
                code: x.LS_YEAR,
                disabled: true,
              };
              this.object.year.options.push(obj);
            });
            this.object.year.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            this.object.year.value = {
              label: arr[0].LS_YEAR,
              code: arr[0].LS_YEAR,
              disabled: true,
            };
          }
        })
        .catch((err) => console.warn(err));
    },
    getLiveStockDataList(data) {
      this.apiGetLiveStockDataList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.table.items = JSON.parse(json.Data);
            this.object.table.totalRows = this.object.table.items.length;
            this.object.table.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    getDataList() {
      if (
        this.object.tetrapodcategory.value != null &&
        this.object.country.value != null &&
        this.object.year.value != null
      ) {
        this.object.table.isBusy = true;
        this.object.table.ifshow = true;
        this.FunctionToken(this.getLiveStockDataList, {
          LS_TYPE: this.object.tetrapodcategory.value.code,
          LS_CITY: this.object.country.value.code,
          LS_YEAR: this.object.year.value.code,
        });
      }
    },
    handleResize() {
      this.object.window.width = window.innerWidth;
    },
  },
  watch: {
    "object.tetrapodcategory.value"() {
      this.getDataList();
    },
    "object.country.value"() {
      this.getDataList();
    },
    "object.year.value"() {
      this.getDataList();
    },
  },
};
</script>
